import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

const DataleoPositioning = () => {
  const { t } = useLang();
  return (
    <section data-testid="positioning-section" className="dl-container py-20">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="dl-overline text-[#00A878]">{t.positioning.eyebrow}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05] text-[#111827]">
            {t.positioning.title}
          </h2>
          <p className="mt-5 text-[#4B5563] text-[16px] leading-relaxed max-w-2xl">
            {t.positioning.body}
          </p>
          <blockquote className="mt-6 border-l-4 border-[#00A878] pl-5 italic text-[#111827] text-[18px] font-display">
            "The real value is not the AI-built app. The real value is the governed decision system behind it."
          </blockquote>
          <Link
            to="/about"
            data-testid="positioning-cta"
            className="inline-flex items-center gap-2 mt-6 px-5 py-3 dl-btn-primary text-sm"
          >
            {t.positioning.cta} →
          </Link>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] bg-[#F3F4F6] border border-[#E5E7EB] overflow-hidden">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/12174c23-18d7-4071-ba97-2cc28aea953f/images/2c87b9388689d7c21fc29bf10db95424e754350f03d610ce22b1d07d7abf69e4.png"
              alt="Dataleo team at work"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataleoPositioning;
